export function makeFullSurveyMeasure<T, DimDto>(
  dto: T,
  dimensions: DimDto[]
): T & { dimensions: DimDto[] } {
  return {
    ...dto,
    dimensions,
  };
}
